import styled from 'styled-components';
import { Input } from 'antd';

import { HAIRLINE_COLOR } from '../styles';

export const CommentTextArea = styled(Input.TextArea)`
	&&,
	&& textarea {
		height: 8rem;
		padding: 0.5rem 0.75rem 0.375rem;
		border: 2px solid ${HAIRLINE_COLOR};
		border-radius: 0.125rem;
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: 1rem;
		line-height: 1.375rem;
	}

	&& textarea::placeholder {
		color: rgba(0, 0, 0, 0.25);
	}
`;
